import cn from 'classnames';
// Styles
import styles from './MerchColorPicker.module.scss';

export type MerchColorOption = {
  value: string;
  isSelected: boolean;
  imageUrl: string;
  colorCode: string;
};

type MerchColorPickerProps = {
  availableOptions: MerchColorOption[];
  allOptions: MerchColorOption[];
  onChange: (color: string) => void;
};

const MerchColorPicker = ({
  availableOptions,
  allOptions,
  onChange,
}: MerchColorPickerProps) => {
  return (
    <div className={styles.optionsContainer}>
      <ul
        className={cn(styles.colorPickerWrapper)}
        role="radiogroup"
        aria-label="merchColorPicker"
      >
        {allOptions.map(
          ({ value, isSelected, colorCode }: MerchColorOption) => {
            const isAvailable = availableOptions.some(
              (item) => item.value === value
            );
            const handleColorChange = () => {
              if (!isAvailable || isSelected) return;
              onChange(value);
            };
            const backgroundColor = colorCode || '#808080';
            return (
              <li key={`${value}`}>
                <div
                  className={cn(styles.optionWrapper, {
                    [styles.disabled]: !isAvailable,
                  })}
                  onClick={handleColorChange}
                  onKeyPress={handleColorChange}
                  role="radio"
                  aria-checked={isSelected}
                  tabIndex={0}
                >
                  <span
                    className={cn(styles.colorOption, {
                      [styles.selectedColor]: isSelected,
                    })}
                    style={{ backgroundColor }}
                    title={value}
                    aria-label={value}
                  />
                </div>
              </li>
            );
          }
        )}
      </ul>
    </div>
  );
};

export default MerchColorPicker;
